import { Component, OnDestroy, OnInit } from '@angular/core';
import { AGENCY_CONTENT_SERVICE_KEY, LINE_OF_BUSINESS_ENUM } from '@ptl/account-management';
import { FormComponentLookup, FormNavigationConfig, DefaultFormConfig, FormPageComponentClass } from '@ptl/forms';
import { ContentStorageService, PtlWindowLocationService } from '@ptl/global-components';
import { Subscription } from 'rxjs';
import { Prospect as ProducerRetrievedProspect } from 'src/app/angular-elements/on-exchange-enrollment/interfaces/on-exchange-prospects-retrieval.producer.response.interface';
import { Prospect as ConsumerRetrievedProspect} from 'src/app/angular-elements/on-exchange-enrollment/interfaces/prospect.interface';
import { OnExchangeEligibilityStateStructure, ON_EXCHANGE_ELIGIBILITY_REDUCER_NAME } from 'src/app/angular-elements/on-exchange-enrollment/reducers/eligibility.reducer';
import { EligibilityManagerService } from 'src/app/angular-elements/on-exchange-enrollment/services/eligibility-manager.service';
import { FFMRedirectService } from 'src/app/angular-elements/on-exchange-enrollment/services/ffmredirect.service';
import { ProspectService } from 'src/app/angular-elements/on-exchange-enrollment/services/prospect.service';
import { CommonUtilityService } from 'src/app/shared/utility-services/common-utility.service';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { PAGE_INDIVIDUAL_ON_EXCHANGE_PLAN_ENROLLMENT_PAYMENT, PAGE_INDIVIDUAL_ON_EXCHANGE_PLAN_ENROLLMENT_PAYMENT_KEYS } from '../configs/content-storage.enum';

/**
 * 1) Payment options ( radio button to select HOW to pay )
 * 2) Payment info ( data associated with making payment )
 * 3) Payment review
 * 4) Payment confirmation
 */
@FormComponentLookup('page-individual-on-exchange-plan-enrollment-payment')
@Component({
    selector: 'app-page-individual-on-exchange-plan-enrollment-payment',
    templateUrl: './page-individual-on-exchange-plan-enrollment-payment.component.html',
    styleUrls: ['./page-individual-on-exchange-plan-enrollment-payment.component.scss'],
    standalone: false
})
export class PageIndividualOnExchangePlanEnrollmentPaymentComponent extends FormPageComponentClass<FormNavigationConfig> implements OnInit, OnDestroy {

  onExchangeApplicationStatusUrl: string;
  contentStorageSubscription: Subscription;
  selectedMarket: LINE_OF_BUSINESS_ENUM;

  constructor(
    private windowLocationService: PtlWindowLocationService,
    private ffmRedirectService: FFMRedirectService,
    private prospectService: ProspectService,
    private reducerUtilityService: ReducerUtilityService,
    private contentStorage: ContentStorageService,
    private commonUtilityService: CommonUtilityService
  ) {
    super();
  }

  ngOnInit(): void {
    this.initPageConfig();
    this.initPageSubscriptions();
    this.contentStorageSubscription = this.contentStorage.contentChanged$.subscribe(() => {
      if (this.contentStorage.getContentMap(PAGE_INDIVIDUAL_ON_EXCHANGE_PLAN_ENROLLMENT_PAYMENT)) {
        const content = this.contentStorage.getContentMap(PAGE_INDIVIDUAL_ON_EXCHANGE_PLAN_ENROLLMENT_PAYMENT) as Map<any, any>;
        this.onExchangeApplicationStatusUrl
          = content.get(PAGE_INDIVIDUAL_ON_EXCHANGE_PLAN_ENROLLMENT_PAYMENT_KEYS.APPLICATION_STATUS_URL) || '/on-exchange/application-status';
      }

      if (this.contentStorage.getContentMap(AGENCY_CONTENT_SERVICE_KEY)) {
        const agencyContent = this.contentStorage.getContentMap(AGENCY_CONTENT_SERVICE_KEY);
        this.selectedMarket = agencyContent['lob'];
      }
    });

  }

  ngOnDestroy(): void {
    this.contentStorageSubscription.unsubscribe();
  }

  /** These might not be necessary */
  nextHook(formConfig): Promise<any> {
    return new Promise((resolve, reject) => {
      this.formPageActions.nextHook(formConfig);
      resolve(resolve);
    });
  }

  /** These might not be necessary */
  submitHook(formConfig): Promise<any> {
    return new Promise(async (resolve, reject) => {
      resolve(true);
    });
  }

  initPageSubscriptions() {
    this.subscriptionGroup.push(
      this.formStreamTrigger.subscribeToFormStream(async (event) => {

        /** LEGACY PAYMENTS */
        if (event.type === 'hideNextButton') {
          this.formConfig.form.formNavigation.nextButton.display = false;
        } else if (event.type === 'hideBackButton') {
          this.formConfig.form.formNavigation.backButton.display = false;
        } else if (event.type === 'triggerNextPage') {
          this.nextHook(this.formConfig).then(() => {
            this.emitCurrentPage('next');
          });
        } else if (event.type === 'triggerBackPage') {
          this.backHook(this.formConfig).then(() => {
            this.emitCurrentPage('back');
          });
        } else if (event.type === 'onExchangePaymentProcessedGoToConfirmationPage') {
          this.windowLocationService.goToUrl(this.formConfig.form.customConfigs.confirmationPageUrl);
        }

        /** HEALTHCARE.GOV PAYMENTS */
        if (event.type === 'payAtMarketplace') {

          const eligibilityState: OnExchangeEligibilityStateStructure
            = this.reducerUtilityService.getComponentStates()[ON_EXCHANGE_ELIGIBILITY_REDUCER_NAME];

          let prospects: ProducerRetrievedProspect[] | ConsumerRetrievedProspect[] = null;
          let matchedProspects: ProducerRetrievedProspect[] | ConsumerRetrievedProspect[] = null;

          if (this.commonUtilityService.isAgent()) {
            prospects = await this.prospectService.getProspectListProducer(this.selectedMarket, 'COMPLETED');
            matchedProspects = prospects.filter(p => p.prospectId === eligibilityState.currentProspectId);
          } else {
            prospects = await this.prospectService.createProspectIfDoesNotExist();
            matchedProspects = prospects.filter(p => p.prospectId === eligibilityState.currentProspectId);
          }

          const prospect = matchedProspects.length > 0 ? matchedProspects[0] : null;

          await this.ffmRedirectService.goToMarketplace(prospect, prospects, true);
          this.windowLocationService.goToUrl(this.onExchangeApplicationStatusUrl);
        }
      })
    );
  }


}
